import { Client } from '@microsoft/microsoft-graph-client'
import { PublicClientApplication, InteractionType } from '@azure/msal-browser'
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser'
import { IMsalContext } from '@azure/msal-react';
import { msalConfig } from '../../AppSettings'
import { UserProfile } from './Model';

export async function getUserProfile(context: IMsalContext): Promise<UserProfile | null> {
  var client = createGraphClient(context);
  var result = await client
    .api('/me')
    .select(['displayName', 'id'])
    .get();

  return result as UserProfile;
}

export async function getUserPicture(context: IMsalContext): Promise<string | null> {
  var client = createGraphClient(context);
  var response = await client
    .api(`/me/photo/$value`)
    .get();

  return await blobToBase64(response);
}

function createGraphClient(context: IMsalContext) : Client {
  const clientApplication = new PublicClientApplication(msalConfig);
  const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(clientApplication, {
    account: context.accounts[0],
    interactionType: InteractionType.Redirect,
    scopes: ["user.read"]
  });

  return Client.initWithMiddleware({ authProvider });
}

const blobToBase64 = (blob: Blob) => new Promise<string>((resolve, reject) => {
  const reader = new FileReader();

  reader.readAsDataURL(blob);
  reader.onload = () => resolve(reader.result as string);
  reader.onerror = error => reject(error);
});